import { AgentData } from '../components/AgentModal';
import logoMaia from '../assets/logo_maia.svg';
import logoMaiaLegal from '../assets/logo_maia_legal.svg';
import logoLucia from '../assets/logo_lucia.svg';
import logoServicing from '../assets/logo_servicing.jpg';
import logoRetail from '../assets/logo_retail.jpg';
import logoAnalytics from '../assets/logo_analytics.jpg';
import logoProduct from '../assets/logo_product.jpg';
import logoHr from '../assets/logo_hr.jpg';
import logoJewel from '../assets/logo_jewel.png';
import { georgeUrl } from '../utils/georgeUrl';

export const agents: AgentData[] = [
  {
    // Live fields (title, description, etc.) are fetched from GET /api/v1/metadata
    // at runtime. Only static/visual fields are defined here.
    id: 'servicing',
    url: georgeUrl('servicing'),
    liveMetadata: true,
    icon: (
      <div className="relative w-full h-full flex items-center justify-center">
        <div className="absolute w-16 h-16 bg-green-100 rounded-full blur-xl opacity-60"></div>
        <div className="relative bg-white p-3 rounded-2xl shadow-sm border border-green-50">
          <img src={logoServicing} alt="Jewel" className="w-16 h-16" />
        </div>
      </div>
    ),
  },
  {
    // Live fields (title, description, etc.) are fetched from GET /api/v1/metadata
    // at runtime. Only static/visual fields are defined here.
    id: 'retail',
    url: georgeUrl('retail'),
    liveMetadata: true,
    icon: (
      <div className="relative w-full h-full flex items-center justify-center">
        <div className="absolute w-16 h-16 bg-green-100 rounded-full blur-xl opacity-60"></div>
        <div className="relative bg-white p-3 rounded-2xl shadow-sm border border-green-50">
          <img src={logoRetail} alt="Jewel" className="w-16 h-16" />
        </div>
      </div>
    ),
  },
  {
    // Live fields (title, description, etc.) are fetched from GET /api/v1/metadata
    // at runtime. Only static/visual fields are defined here.
    id: 'analytics',
    url: georgeUrl('analytics'),
    liveMetadata: true,
    icon: (
      <div className="relative w-full h-full flex items-center justify-center">
        <div className="absolute w-16 h-16 bg-green-100 rounded-full blur-xl opacity-60"></div>
        <div className="relative bg-white p-3 rounded-2xl shadow-sm border border-green-50">
          <img src={logoAnalytics} alt="Jewel" className="w-16 h-16" />
        </div>
      </div>
    ),
  },
  {
    // Live fields (title, description..) are fetched from GET /api/v1/metadata
    // at runtime. Only static/visual fields are defined here.
    // Public agent: /v1/access is called but does not check Okta groups —
    // it always returns 200. No access restriction for this agent.
    id: 'product',
    url: georgeUrl('product'),
    liveMetadata: true,
    icon: (
      <div className="relative w-full h-full flex items-center justify-center">
        <div className="absolute w-16 h-16 bg-green-100 rounded-full blur-xl opacity-60"></div>
        <div className="relative bg-white p-3 rounded-2xl shadow-sm border border-green-50">
          <img src={logoProduct} alt="Product" className="w-16 h-16" />
        </div>
      </div>
    ),
  },
  {
    // Live fields (title, description..) are fetched from GET /api/v1/metadata
    // at runtime. Only static/visual fields are defined here.
    // Public agent: /v1/access is called but does not check Okta groups —
    // it always returns 200. No access restriction for this agent.
    id: 'hr',
    url: georgeUrl('hr'),
    liveMetadata: true,
    icon: (
      <div className="relative w-full h-full flex items-center justify-center">
        <div className="absolute w-16 h-16 bg-green-100 rounded-full blur-xl opacity-60"></div>
        <div className="relative bg-white p-3 rounded-2xl shadow-sm border border-green-50">
          <img src={logoHr} alt="HR" className="w-16 h-16" />
        </div>
      </div>
    ),
  },
  {
    id: 'jewel',
    title: 'Jewel',
    url: 'https://tiffanyjewel.chat/',
    description: 'Jewel is the IT Support Agent that can help any employee on IT support question',
    tags: ['IT', 'Support'],
    fullDescription:
      "Jewel is Tiffany's answer to the perennial IT support challenge: how do you provide fast, effective, and personalized help to a global workforce, across languages and time",
    status: 'Indus',
    kpis: [
      { label: 'Knowledge base articles', value: '1,100+' },
      { label: 'Languages', value: '10+' },
      { label: 'Agent phase', value: 'Production' },
    ],
    coreCapabilities: [
      {
        name: 'IT Support',
        description:
          'Wide range of IT support topics including password resets, software troubleshooting, and hardware issues.',
        icon: '🧑‍💻',
      },
    ],
    owners: {
      agentOwner: 'Support Team',
      businessOwner: 'Gijo George',
      supportContact: 'george@tiffany.com',
      version: '2.0.0',
    },
    updates: [
      {
        type: 'Update',
        version: 'v2.0.0',
        title: 'Second version',
        description: 'More powerful than ever now Jewel can act and extend its capabilities.',
        date: 'Dec 2025',
      },
      {
        type: 'New',
        version: 'v1.0.0',
        title: 'First version',
        description: 'First Jewel version available on teams and Ring for any Tiffany employee.',
        date: 'Sept 2025',
      },
    ],
    faqs: [
      {
        question: 'Where can I find my ticket opened by Jewel ?',
        answer:
          'Jewel is fully integrated with Service Now and all tickets can be found on the Ring.',
      },
      {
        question: 'Can I reset my password using Jewel ?',
        answer: 'Yes you can reset your password using Jewel.',
      },
    ],
    icon: (
      <div className="relative w-full h-full flex items-center justify-center">
        <div className="absolute w-16 h-16 bg-[#81D8D0] rounded-full blur-xl opacity-40"></div>
        <img src={logoJewel} alt="Jewel" className="w-16 h-16" />
      </div>
    ),
  },
  {
    id: 'maia',
    title: 'MaIA',
    url: 'https://maia.lvmh.com/',
    iconBackground: 'bg-white border border-gray-200',
    iconModalScale: 'scale-[1.3]',
    description:
      'MaIA is LVMH’s secure AI assistant, crafted to deliver intelligent and reliable support across the Group',
    tags: ['General'],
    fullDescription:
      'MaIA is LVMH’s secure AI assistant, crafted to deliver intelligent and reliable support across the Group. Launched in December 2023, it now serves as our all-purpose GenAI service with 4 models available (ChatGPT, Gemini, Claude, Mistral) and ongoing feature updates.',
    status: 'Indus',
    kpis: [
      { label: 'Users', value: '3,300+' },
      { label: 'Questions answered', value: '586k+' },
      { label: 'Feedback rate', value: '0.09%' },
    ],
    coreCapabilities: [
      {
        name: 'Project Management',
        description: 'Writing specifications, creating reports, creating communication materials',
        icon: '📑',
      },
      {
        name: 'Personal assistant',
        description:
          'Provide support assistance, analyze user insights, offer sales coaching, customize and personalize messages, and handle copywriting and translation.',
        icon: '👨‍💻',
      },
      {
        name: 'Web Parsing',
        description:
          'Read webpage’s HTML & pull out meaningful elements: summarize pages, compare sections, extract structured data',
        icon: '🌐',
      },
      {
        name: 'Style',
        description:
          'Enhance text with preset or custom tones (e.g.straightforward, creative, empathic, analytical)',
        icon: '🔖',
      },
      {
        name: 'Save My Prompt',
        description:
          'Save effective prompts with documents and selected model  as templates to maximize consistency and speed.',
        icon: '📚',
      },
      {
        name: 'Multi-Models',
        description:
          'Select among the best available models (GPT, Gemini, Mistral, Claude) according to the task to complete',
        icon: '🔀',
      },
    ],
    owners: {
      agentOwner: 'LVMH Group',
      businessOwner: 'LVMH Group',
      supportContact: 'lvmh.fwd@lvmh.com',
      version: '2.8.1',
    },
    updates: [],
    faqs: [],
    icon: (
      <div className="relative w-full h-full flex items-center justify-center">
        <div className="absolute w-16 h-16 bg-[#81D8D0] rounded-full blur-xl opacity-40"></div>
        <img src={logoMaia} alt="MaIA" className="w-16 h-16 scale-150" />
      </div>
    ),
  },
  {
    id: 'maia-legal',
    title: 'MaIA For Legal',
    url: 'https://legal.maia.lvmh.com/',
    iconBackground: 'bg-white border border-gray-200',
    iconModalScale: 'scale-[1.3]',
    description:
      'MaIA for Legal is a specialized, secure extension of LVMH’s internal MaIA platform, purpose-built for legal teams. ',
    tags: ['Legal'],
    fullDescription:
      'MaIA for Legal is a specialized, secure extension of LVMH’s internal MaIA platform, purpose-built for legal teams. It pairs general GenAI capabilities with LVMH legal knowledge, anchored by Lexchange as the internal centralized and secure database.',
    status: 'Indus',
    kpis: [
      { label: 'Users', value: '8' },
      { label: 'Questions answered', value: '390' },
      { label: 'Agent phase', value: 'Production' },
    ],
    coreCapabilities: [
      {
        name: 'Legal Contract Management',
        description:
          'Contract Generation with or without a template. Contrat improvement Suggestions',
        icon: '📖',
      },
      {
        name: 'Legal Benchmarking',
        description: 'Clause Analysis. Contract and Document Comparison',
        icon: '⚖️',
      },
      {
        name: 'Legal synthesis',
        description: 'Document and insight search. Legal text/contract summarization',
        icon: '🖋️',
      },
    ],
    owners: {
      agentOwner: 'LVMH Group',
      businessOwner: 'LVMH Group',
      supportContact: 'lvmh.fwd@lvmh.com',
      version: null,
    },
    updates: [],
    faqs: [],
    icon: (
      <div className="relative w-full h-full flex items-center justify-center">
        <div className="absolute w-16 h-16 bg-[#81D8D0] rounded-full blur-xl opacity-40"></div>
        <img src={logoMaiaLegal} alt="MaIA" className="w-16 h-16 scale-150" />
      </div>
    ),
  },
  {
    id: 'lucia',
    title: 'Lucia',
    url: 'https://lucia.lvmh.com/',
    iconBackground: 'bg-white border border-gray-200',
    iconModalScale: 'scale-[1.3]',
    description: 'LucIA is LVMH’s secure image and video generation platform',
    tags: ['Image', 'Video'],
    fullDescription:
      'LucIA is LVMH’s secure image and video generation platform, purpose-built to safeguard data, IP, and brand codes while pushing the boundaries of creativity for all Maisons.',
    status: 'Indus',
    kpis: [{ label: 'Agent phase', value: 'Production' }],
    coreCapabilities: [
      {
        name: 'Text to Image',
        description:
          'Combine your description with a reference image to generate visuals that align with your intended style and maintain visual consistency.',
        icon: '🖼️',
      },
      {
        name: 'Image to Image',
        description:
          'Give existing images a creative transformation by enhancing, remixing, or applying new styles to develop fresh content from your own visuals.',
        icon: '🔀',
      },
      {
        name: 'Describe',
        description:
          'Upload any image and receive a clear, detailed text description, perfect for captions, accessibility, or quickly understanding visual content.',
        icon: '📖',
      },
      {
        name: 'Inpaint',
        description:
          'Edit specific parts of an image by selecting the area and describing the change you want, whether removing, replacing, or adding elements.',
        icon: '🖌️',
      },
      {
        name: 'Videos',
        description:
          'Convert your ideas or scripts into animated video clips by providing a description, allowing LucIA to create engaging motion visuals.',
        icon: '📼',
      },
    ],
    owners: {
      agentOwner: 'LVMH Group',
      businessOwner: 'LVMH Group',
      supportContact: 'lvmh.fwd@lvmh.com',
      version: null,
    },
    updates: [],
    faqs: [],
    icon: (
      <div className="relative w-full h-full flex items-center justify-center">
        <div className="absolute w-16 h-16 bg-[#81D8D0] rounded-full blur-xl opacity-40"></div>
        <img src={logoLucia} alt="MaIA" className="w-16 h-16 scale-150" />
      </div>
    ),
  },
];
